export default {
  title_one: 'Uso único, {{discount}}',
  title_other: '{{count}} usos, {{discount}}',
  labels: {
    fixed_discount: '{{discount}} de descuento total',
    percentage_discount: 'Descuento porcentual',
  },
  buttons: {
    add_component: 'Agregar uso',
  },
};
